import { render, staticRenderFns } from "./PWCollateProductAdd.vue?vue&type=template&id=419cd778&"
import script from "./PWCollateProductAdd.vue?vue&type=script&lang=js&"
export * from "./PWCollateProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports